// Vendors
import React from "react";
import { usePromiseTracker } from "react-promise-tracker";

// Components
import Loader from "react-loader-spinner";

// Styles
import "./spinner.scss";

export const Spinner = (props) => {
  const { promiseInProgress } = usePromiseTracker();

  return (
    promiseInProgress && (
      <div className="spinner">
        <Loader type="ThreeDots" color="#007bff" height="100" width="100" />
      </div>
    )
  );
};

